export default __webpack_public_path__ + "static/tooltip-contents-do-dark-ea5e40e2faf121337795dcc5435e6144.png";